import React, { useState } from "react";
import "./StaticPage.css";
import "./Contact.css";
import "./Partner.css";

var BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:4000";

var BENEFITS = [
  { title: "Your Product, Our Brand", desc: "We market and sell your quality products under the trusted PureJar label — you focus on making, we handle the rest." },
  { title: "Built-In Distribution", desc: "Tap into our growing customer base, e-commerce platform, and pan-India Shiprocket logistics from day one." },
  { title: "Quality-First Curation", desc: "We only partner with makers who share our standards — authentic sourcing, honest ingredients, and genuine quality." },
  { title: "Transparent Partnership", desc: "Clear terms, fair margins, and full visibility. We grow when you grow." },
];

var STEPS = [
  { n: "01", title: "Reach Out", desc: "Tell us about your product and your story using the form below." },
  { n: "02", title: "Sample & Review", desc: "We taste-test and assess quality, sourcing, and fit with our brand values." },
  { n: "03", title: "Onboard", desc: "We agree on terms, packaging, and pricing — then bring your product onto PureJar." },
  { n: "04", title: "Grow Together", desc: "Your product goes live. We market, sell, and ship while you scale production." },
];

export default function Partner() {
  var [form, setForm] = useState({ businessName: "", contactName: "", email: "", phone: "", product: "", message: "" });
  var [status, setStatus] = useState("");
  var [sending, setSending] = useState(false);
  var [errors, setErrors] = useState({});

  function validate() {
    var errs = {};
    if (!form.businessName.trim()) errs.businessName = 'Please enter your business name.';
    if (!form.contactName.trim()) errs.contactName = 'Please enter a contact person.';
    var emailOk = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email);
    if (!emailOk) errs.email = 'Please enter a valid email address.';
    var digits = form.phone.replace(/\D/g, '').slice(-10);
    if (!/^[6-9]\d{9}$/.test(digits)) errs.phone = 'Please enter a valid 10-digit phone number.';
    if (!form.product.trim()) errs.product = 'Please tell us what you make.';
    return errs;
  }

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: null });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    var errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    setSending(true); setStatus("");
    try {
      var res = await fetch(BACKEND_URL + "/api/partner", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, type: "partner" }),
      });
      if (res.ok) { setStatus("success"); setForm({ businessName: "", contactName: "", email: "", phone: "", product: "", message: "" }); }
      else setStatus("error");
    } catch (err) { setStatus("error"); }
    finally { setSending(false); }
  }

  return (
    <div className="static-page">
      {/* Hero */}
      <div className="partner-hero">
        <div className="partner-hero-inner">
          <span className="section-label">Partner With Us</span>
          <h1>Grow your product<br/>with PureJar</h1>
          <p>Are you a maker of quality food or wellness products? Let's bring your craft to more homes — under a brand people already trust.</p>
          <a href="#partner-form" className="btn-primary">Start the Conversation</a>
        </div>
      </div>

      {/* What is white-label */}
      <div className="partner-section">
        <div className="partner-intro">
          <h2>What is a PureJar partnership?</h2>
          <p>
            We white-label and co-brand quality products from trusted makers. You bring the product and the craft;
            we bring the brand, the platform, the marketing, and the logistics. Together, we get genuine products
            into homes across India — while you focus on what you do best.
          </p>
        </div>
      </div>

      {/* Benefits */}
      <div className="partner-section partner-benefits-section">
        <div className="partner-container">
          <h2 className="partner-section-title">Why partner with us</h2>
          <div className="partner-benefits">
            {BENEFITS.map(function(b, i) {
              return (
                <div key={i} className="partner-benefit-card">
                  <h3>{b.title}</h3>
                  <p>{b.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* How it works */}
      <div className="partner-section">
        <div className="partner-container">
          <h2 className="partner-section-title">How it works</h2>
          <div className="partner-steps">
            {STEPS.map(function(s, i) {
              return (
                <div key={i} className="partner-step">
                  <span className="partner-step-num">{s.n}</span>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Form */}
      <div className="partner-section partner-form-section" id="partner-form">
        <div className="partner-form-container">
          <div className="partner-form-intro">
            <h2>Let's talk</h2>
            <p>Fill in your details and our team will get back to you within 2–3 business days.</p>
          </div>
          {status === "success" ? (
            <div className="contact-success">
              <div className="contact-success-icon">✓</div>
              <h3>Thanks for reaching out!</h3>
              <p>We've received your partnership inquiry and will be in touch within 2–3 business days.</p>
              <button className="btn-primary" onClick={function() { setStatus(""); }}>Submit Another</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form partner-form">
              <div className="partner-form-row">
                <div className="form-group">
                  <label>Business Name</label>
                  <input type="text" name="businessName" value={form.businessName} onChange={handleChange} placeholder="Your company" />
                  {errors.businessName && <span className="field-error">{errors.businessName}</span>}
                </div>
                <div className="form-group">
                  <label>Contact Person</label>
                  <input type="text" name="contactName" value={form.contactName} onChange={handleChange} placeholder="Your name" />
                  {errors.contactName && <span className="field-error">{errors.contactName}</span>}
                </div>
              </div>
              <div className="partner-form-row">
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="you@company.com" />
                  {errors.email && <span className="field-error">{errors.email}</span>}
                </div>
                <div className="form-group">
                  <label>Phone</label>
                  <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="10-digit mobile" />
                  {errors.phone && <span className="field-error">{errors.phone}</span>}
                </div>
              </div>
              <div className="form-group">
                <label>What product do you make?</label>
                <input type="text" name="product" value={form.product} onChange={handleChange} placeholder="e.g. Honey, spices, snacks, wellness products..." />
                  {errors.product && <span className="field-error">{errors.product}</span>}
              </div>
              <div className="form-group">
                <label>Tell us more</label>
                <textarea name="message" value={form.message} onChange={handleChange} placeholder="Your story, sourcing, production capacity, anything you'd like to share..." rows="4"></textarea>
              </div>
              {status === "error" && <p className="contact-error">Something went wrong. Please try again or email partners@purejar.in.</p>}
              <button type="submit" className="btn-primary" disabled={sending}>{sending ? "Sending..." : "Submit Inquiry"}</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
